import type { DocumentInvite, CreateDocumentInviteData } from "@/types/document-invite";

// Mock data per document invites
const mockDocumentInvites: DocumentInvite[] = [
    {
        id: "1",
        documentId: "doc-1",
        shipperId: "1",
        type: "receiver",
        receiverId: "2",
        status: "pending",
        invitedAt: new Date("2024-01-10"),
        notes: "Per favore rivedi questo documento",
    },
    {
        id: "2",
        documentId: "doc-1",
        shipperId: "1",
        type: "receiver",
        receiverId: "4",
        status: "accepted",
        invitedAt: new Date("2024-01-15"),
    },
    {
        id: "3",
        documentId: "doc-1",
        shipperId: "1",
        type: "email",
        email: "custom@example.com",
        status: "pending",
        invitedAt: new Date("2024-01-20"),
    },
    // Mock data per document-review (usando documentId dal componente)
    {
        id: "4",
        documentId: "1", // Document ID dal componente
        shipperId: "1",
        type: "receiver",
        receiverId: "2", // Global Partners Corp
        status: "accepted",
        invitedAt: new Date("2024-01-18"),
        notes: "Invito accettato per revisione",
    },
    {
        id: "5",
        documentId: "1", // Document ID dal componente
        shipperId: "1",
        type: "receiver",
        receiverId: "6", // European Trading Co.
        status: "pending",
        invitedAt: new Date("2024-01-25"),
        notes: "In attesa di risposta",
    },
];

// In-memory storage
let documentInvites = [...mockDocumentInvites];

// Helper functions per CRUD operations
export const documentInviteService = {
    // Get all invites
    getAll: (): DocumentInvite[] => {
        return [...documentInvites];
    },

    // Get invite by ID
    getById: (id: string): DocumentInvite | undefined => {
        return documentInvites.find((invite) => invite.id === id);
    },

    // Get invites by document ID
    getByDocumentId: (documentId: string): DocumentInvite[] => {
        return documentInvites.filter((invite) => invite.documentId === documentId);
    },

    // Get invites by receiver ID
    getByReceiverId: (receiverId: string): DocumentInvite[] => {
        return documentInvites.filter((invite) => invite.receiverId === receiverId);
    },

    // Create new invite
    create: (data: CreateDocumentInviteData): DocumentInvite => {
        const newInvite: DocumentInvite = {
            id: (documentInvites.length + 1).toString(),
            ...data,
            status: "pending",
            invitedAt: new Date(),
        };
        documentInvites.push(newInvite);
        return newInvite;
    },

    // Generate share link
    generateShareLink: (documentId: string): string => {
        const token = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        const baseUrl = typeof window !== "undefined" ? window.location.origin : "";
        return `${baseUrl}/document-review/${documentId}?token=${token}`;
    },

    // Resend invite (simula re-invio aggiornando la data)
    resendInvite: (id: string): DocumentInvite | null => {
        const invite = documentInvites.find((inv) => inv.id === id);
        if (!invite) return null;

        invite.invitedAt = new Date();
        return invite;
    },

    // Revoke invite
    revokeInvite: (id: string): boolean => {
        const index = documentInvites.findIndex((invite) => invite.id === id);
        if (index === -1) return false;

        documentInvites.splice(index, 1);
        return true;
    },

    // Delete invite (alias per revokeInvite per compatibilità)
    delete: (id: string): boolean => {
        const index = documentInvites.findIndex((invite) => invite.id === id);
        if (index === -1) return false;

        documentInvites.splice(index, 1);
        return true;
    },
};

